import { Navigate, useLocation } from "react-router-dom";
import { getUserData } from "../../../system";

const ProtectedRoute = ({ children }) => {
  const user = getUserData();
  const location = useLocation();

  // If not logged in -> go to login
  if (!user || Object.keys(user).length === 0) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Otherwise allow access to children (MainLayout + nested routes)
  return children;
};

export default ProtectedRoute;
